export class Product {
    public id: number;
    public name: string;
    public artno: number; 
    public image: string;   

    public shelf: number;
    public position: number;
    public coords: string;

    public volume : string;
    public shade: string;
    public spf: number;

    public available: number; 
    public product_id: number;

    // public benefits: string;
    // public benefits_take: string;
    // public benefits_take_detail: string;  

    // public benefits_en: string;  
    // public benefits_fr: string;  
    // public benefits_ar: string;  

    // public benefits_en_take: string;  
    // public benefits_fr_take: string;  
    // public benefits_ar_take: string;

    // public benefits_en_take_detail: string;  
    // public benefits_fr_take_detail: string;  
    // public benefits_ar_take_detail: string;
    
    //public reviews_count: number;
    //public badged: number;

    public productExt: ProductExt;
}

export class ProductExt {
    public id: number;
    public url: string;
    public url_buy: string;
    public ranking: number;
    public description: string;
    public properties: string;
    public ingredients: string;
    public instructions: string;
}

// export class ProductRanking {
//     public productId: number;
//     public ranking: number;
//     public reviews_count: number;
// }

export class ProductFav {
    public id: number;
    public type: string;
}


// WEBPACK FOOTER //
// ./src/models/product.ts